import { Component, OnInit } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";

export interface ChoiceDialogOptions {
  text: string;
  action: string;
  status: "secondary" | "primary";
}

@Component({
  selector: "app-choice-dialog",
  templateUrl: "./choice-dialog.component.html",
  styleUrls: ["./choice-dialog.component.scss"],
})
export class ChoiceDialogComponent implements OnInit {
  constructor(private dialogRef: NbDialogRef<ChoiceDialogComponent>) {}
  ngOnInit(): void {}

  get size(): string {
    return this["data"]?.size || "wide";
  }
  get title(): string {
    return this["data"]?.title || "";
  }
  get text(): string {
    return this["data"]?.text || "";
  }

  get fit(): boolean {
    return this["data"]?.fit || this["data"]?.fit === false
      ? this["data"]?.fit
      : true;
  }
  get fullHeight(): boolean {
    return this["data"]?.fullHeight || this["data"]?.fullHeight === false
      ? this["data"]?.fullHeight
      : false;
  }

  get options(): ChoiceDialogOptions {
    return this["data"]?.options || [];
  }

  get showCloseButton(): boolean {
    return this["data"]?.showCloseButton || true;
  }

  handleClick(action) {
    this.dialogRef.close(action);
  }
}
